import { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { userLogin } from "../../Services/Auth";
import Authenticator from "../../UserDashboard/Authenticator/Authenticator";
import Alert from "../Alert";
import queryString from "query-string";
import { toast } from "react-toastify";

import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Clip from "../Comps-Utils/ClipLoader";
import { ToasterContext } from "../../App";
import { RightsContext } from "../../App";
const Login = () => {
  const [alert, setAlert] = useState({ visible: false });
  const [loginFlag, setLoginFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState("");
  // eslint-disable-next-line
  const [tostify, setTostify] = useContext(ToasterContext);
  // eslint-disable-next-line
  const [rights, setRights] = useContext(RightsContext);
  const [loginInfo, setLoginIngo] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginIngo({ ...loginInfo, [name]: value });
  };
  //
  const [showPass, setShowPass] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("session_error")) {
      toast.error("Your session has expired, please login again.");
      localStorage.removeItem("session_error");
    }
  }, []);

  const checkValidation = () => {
    let errors = {};
    const regExp = new RegExp(
      // eslint-disable-next-line
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    );
    if (loginInfo.email === "") {
      errors.email = "Email is required";
    } else if (!regExp.test(loginInfo.email)) {
      errors.email = "Email is not valid";
    }
    if (loginInfo.password === "") {
      errors.password = "Password is required";
    }
    if (loginInfo.password.length < 7) {
      errors.password = "Password is less than 8 character";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    } else {
      setErrors({});
      return true;
    }
  };
  const handleVisiblityPassword = () => {
    setShowPass(!showPass);
  };

  const { search } = useLocation();
  const queryParams = () => {
    const values = queryString.parse(search);
    return values;
  };

  const handleSubmit = async (e) => {
    const validate = checkValidation();
    e.preventDefault();
    var res;
    const utmParams = queryParams();
    if (validate) {
      setLoading(true);
      const obj = {
        email: loginInfo.email,
        password: loginInfo.password,
        utmParams: utmParams,
      };
      // calling services
      res = await userLogin(obj);
      if (res.message === "Successful") {
        setLoading(false);
        if (res.auth === true) {
          setLoginFlag(true);
          setUserInfo(res.user);
          // window.location.reload();
        } else {
          setRights(
            res && res.user && res.user.rights ? res.user.rights[0] : []
          );
          window.location.reload();
          // window.location.href = "/dashboard";
          // setTostify({
          //   ...tostify,
          //   visible: true,
          //   key: Math.random().toString(36).substring(7),
          //   type: "success",
          //   message: res.message,
          // });
        }
      } else {
        setLoading(false);
        setTostify({
          ...tostify,
          visible: true,
          key: Math.random().toString(36).substring(7),
          type: res && res.status === 200 ? "success" : "error",
          message: res.message,
        });
      }
    }
  };
  return (
    <>
      <Alert setAlert={setAlert} {...alert} />
      {loginFlag === false ? (
        <div className="user-ath">
          <div className="user-ath-page">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8  text-center">
                  <div className="user-ath-logo logo-width">
                    <Link to={"/"}>
                      <img
                        src="images/logo.png"
                        srcSet="images/logo.png"
                        alt="icon"
                      />
                    </Link>
                  </div>
                  <div className="user-ath-box">
                    <h4>Login to Your Account</h4>
                    <form action="index.html" className="user-ath-form">
                      {/* <div className="note note-lg note-no-icon note-danger">
                                <p>Your email and password is invalid.</p>
                            </div> */}
                      <div className="input-item">
                        <input
                          type="text"
                          placeholder="Your Email"
                          className="input-bordered"
                          name="email"
                          onChange={handleChange}
                        />
                        <span className="error1">{errors.email}</span>
                      </div>
                      <div className="input-item passwordInput">
                        <input
                          type={showPass ? "password" : "text"}
                          placeholder="Password"
                          className="input-bordered"
                          name="password"
                          onChange={handleChange}
                        />
                        <i
                          className="passwordIcon"
                          onClick={handleVisiblityPassword}
                        >
                          {showPass ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </i>
                        <span className="error1">{errors.password}</span>
                      </div>
                      <div className="gaps"></div>
                      <div className="d-flex justify-content-between align-items-center">
                        <button
                          onClick={handleSubmit}
                          className="btn btn-primary"
                        >
                          {loading ? <Clip /> : <> Log in</>}
                        </button>
                        <Link to={"/reset-password"} className="simple-link">
                          Forgot password?
                        </Link>
                      </div>
                    </form>
                  </div>
                  <div className="gaps-2x"></div>
                  <div className="form-note">
                    {" "}
                    Not a member? <Link to={"/signup"}>Sign up now</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Authenticator userInfo={userInfo} />
      )}
    </>
  );
};
export default Login;
